import { render, staticRenderFns } from "./SyncMenu.vue?vue&type=template&id=3153805c&lang=pug"
import script from "./SyncMenu.vue?vue&type=script&lang=js"
export * from "./SyncMenu.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports